var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
const TypographyStyle = styled.div `
  line-height: ${props => props.theme.fonts.lineHeight};
  display: ${(props) => (props.isBlock ? 'block' : 'inline-block')};
  margin-top: 0;
  font-family: ${props => props.theme.fonts.fontFamily};
  ${''}
  color : ${(props) => props.theme.utils.getColor(props.color)};
  ${''}
  font-size: ${(props) => props.theme.utils.getSize(props.size)};
  ${''}
  font-weight: ${(props) => props.weight};
  overflow-wrap: ${(props) => props.overflowWrap};
  font-style: ${(props) => props.fontStyle};
  text-decoration: ${(props) => props.decoration};
  text-align: ${(props) => props.align};
  ${props => props.mediaQuery}
`;
const Typography = (_a) => {
    var { children, color = 'main', size = 'article', weight, overflowWrap, fontStyle = 'normal', decoration, align = 'left', isBlock = false, isLoading = false, mediaQuery, conditionalRender = true, excludeMeFromLoadingContext = false, skeleton } = _a, props = __rest(_a, ["children", "color", "size", "weight", "overflowWrap", "fontStyle", "decoration", "align", "isBlock", "isLoading", "mediaQuery", "conditionalRender", "excludeMeFromLoadingContext", "skeleton"]);
    const { loadingContext } = useCronoSkeleton();
    return ((loadingContext && excludeMeFromLoadingContext === false) || isLoading
        ? _jsx(Skeleton, Object.assign({ height: size, width: "100%", margin: "v", display: isBlock ? 'block' : 'inline-block' }, skeleton))
        : conditionalRender
            ? _jsx(TypographyStyle, Object.assign({ color: color, size: size, weight: weight, overflowWrap: overflowWrap, fontStyle: fontStyle, decoration: decoration, align: align, isBlock: isBlock, mediaQuery: mediaQuery }, props, { children: children }))
            : null);
};
export default Typography;
